<template>
    <v-app>
        <v-container>
            <v-row justify="center">
                <v-col cols="12" class="mb-8">
                    <NavBar v-if="isProviderView === 'false'" class="mb-8" page-title="My Progress" />
                    <NavBar v-else class="mb-8 top-bar" page-title="Patient Progress" disable-actions="true" 
                    back-arrow="true" disable-menu="true" is-provider-view="true"/>
                </v-col>

                <v-col cols="12">
                    <v-card class="bg-aqua-teal">
                        <v-card-title class="text-center text-wrap">
                            {{ (isProviderView === "true") ? `${progressSummary.patient}'s Progress` : "My Progress" }}
                        </v-card-title>
                        <v-card-text class="text-center">
                            This page offers an overview of your {{ (isProviderView === "true") ? "patient's" : "" }}
                            personal wellness, displaying key insights and
                            visualizations to help {{ (isProviderView === "true") ? "you" : "" }}
                            track {{ (isProviderView === "true") ? "their" : "your" }} growth and well-being over time.
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-expansion-panels class="pa-4" multiple>
                    <v-expansion-panel>
                        <template v-slot:title>
                            Progress Overview
                        </template>

                        <v-expansion-panel-text>
                            {{ progressSummary.summary }}
                        </v-expansion-panel-text>
                    </v-expansion-panel>

                    <v-expansion-panel>
                        <template v-slot:title>
                            Progress Charts

                        </template>

                        <v-expansion-panel-text>
                            <div class="d-flex justify-center">
                                <div class="d-flex justify-center mt-2">
                                    <v-row>
                                        <v-col v-if="screenAtLeastMedium">
                                            <progress-chart-dropdown button-label="Chart Type" class="mx-2"
                                                @update-type="setChartDataChartType" :types="chartDataChartTypes"
                                                :current-value="chartDataChartType" />

                                            <progress-chart-dropdown button-label="Time Period" class="mx-2"
                                                @update-type="setIntervalType" :types="intervalTypes"
                                                :current-value="intervalType" />

                                            <progress-chart-dropdown button-label="Wellness Levels" class="mx-2"
                                                @update-type="setWellnessType" :types="wellnessTypes"
                                                :current-value="wellnessType" />
                                            <v-btn color="aqua-teal" button-label="Date Range"
                                                @click="datePickerOptions = true">
                                                Select Date Range
                                            </v-btn>
                                            <!-- <v-btn color="aqua-teal" class="mx-2" @click="otherOptionsDialog = true">
                                                Other Filter
                                            </v-btn> -->


                                        </v-col>
                                    </v-row>
                                </div>
                                <v-btn v-if="!screenAtLeastMedium" color="aqua-teal"
                                    @click="optionsDialog = true">Options</v-btn>
                                <v-dialog v-model="optionsDialog" :max-width="600">
                                    <v-card>
                                        <v-card-title class="text-center text-wrap bg-aqua-teal">Options</v-card-title>
                                        <v-card-text>
                                            <v-row fluid>
                                                <v-col cols="12" class="d-flex justify-center">
                                                    <progress-chart-dropdown button-label="Chart Type" class="mx-2"
                                                        @update-type="setChartDataChartType"
                                                        :types="chartDataChartTypes"
                                                        :current-value="chartDataChartType" />
                                                </v-col>

                                                <v-col v-if="!screenAtLeastMedium" cols="12"
                                                    class="d-flex justify-center">
                                                    <progress-chart-dropdown button-label="Time Period"
                                                        @update-type="setIntervalType" :types="intervalTypes"
                                                        :current-value="intervalType" />
                                                </v-col>

                                                <v-col v-if="!screenAtLeastMedium" cols="12"
                                                    class="d-flex justify-center">
                                                    <progress-chart-dropdown button-label="Wellness Levels"
                                                        @update-type="setWellnessType" :types="wellnessTypes"
                                                        :current-value="wellnessType" />
                                                </v-col>
                                                <v-col v-if="!screenAtLeastMedium" cols="12"
                                                    class="d-flex justify-center">
                                                    <v-btn color="aqua-teal" button-label="Date Range"
                                                        @click="datePickerOptions = true">
                                                        Select Date Range
                                                    </v-btn>
                                                </v-col>

                                                <!-- <v-col cols="12" class="d-flex justify-center">
                                                    <v-btn color="aqua-teal" @click="true">
                                                        Other Filter
                                                    </v-btn>
                                                </v-col> -->
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-dialog>
                            </div>

                            <!-- ✅ Pop-up Dialog for Other Filter Options -->
                            <v-dialog v-model="otherOptionsDialog" width="auto">
                                <v-card>
                                    <v-card-title>Select Date Range</v-card-title>
                                    <v-card-text>No more options available.</v-card-text>
                                    <v-card-actions class="bg-aqua-teal">
                                        <v-btn @click="otherOptionsDialog = false">Close</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <!-- ✅ Pop-up Dialog for Date Range Options -->
                            <v-dialog v-model="datePickerOptions" width="auto">
                                <v-card>
                                    <v-card-title class="bg-aqua-teal text-center text-wrap">Select Date
                                        Range</v-card-title>
                                    <v-card-actions class="mt-2">
                                        <v-btn class="bg-aqua-teal" @click="startDatePicker = true">Start Date</v-btn>
                                        <v-btn class="bg-aqua-teal" @click="endDatePicker = true">End Date</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <!-- ✅ Pop-up Dialog for Date Picker -->
                            <v-dialog v-model="startDatePicker" width="auto">
                                <!-- End Date Picker -->
                                <v-date-picker color="aqua-teal" v-model="startDate" :max="today"></v-date-picker>

                                <v-card>
                                    <v-card-actions>
                                        <v-btn class="bg-aqua-teal" @click="startDatePicker = false">Close</v-btn>
                                        <v-btn class="bg-aqua-teal" @click="startDate = null">Clear</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <!-- ✅ Pop-up Dialog for Date Picker -->
                            <v-dialog v-model="endDatePicker" width="auto">
                                <!-- End Date Picker -->
                                <v-date-picker color="aqua-teal" v-model="endDate" :max="today"></v-date-picker>

                                <v-card>
                                    <v-card-actions>
                                        <v-btn class="bg-aqua-teal" @click="endDatePicker = false">Close</v-btn>
                                        <v-btn class="bg-aqua-teal" @click="endDate = null">Clear</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <Bar :max-height="600" :options="chartOptions" :data="chartData"></Bar>
                        </v-expansion-panel-text>
                        <v-expansion-panel-text>
                            <v-expansion-panel-text>
                                <div v-if="!chartDataExists" class="d-flex justify-center">
                                    <h3>No {{ wellnessType }} Data Available</h3>
                                </div>
                                <div v-show="chartDataExists && chartDataChartType === 'Line'">
                                    <MyProgressPageLineChart :chart-data="chartData" :enabledType="true"
                                        :chart-type="selectedChartType" :chart-options="chartOptions" />
                                </div>
                                <div v-show="chartDataExists && chartDataChartType === 'Bar'">
                                    <MyProgressPageBarChart :chart-data="chartData" :enabledType="true"
                                        :chart-type="selectedChartType" :chart-options="chartOptions" />
                                </div>
                                <v-divider class="my-4"></v-divider>
                                <div v-show="tasksDataExists">
                                    <MyProgressPageTaskBarChart :chart-data="tasksData" :enabledType="false"
                                        :chart-options="chartOptions" :chart-title="tasksChartTitle" />
                                </div>
                                <v-divider v-show="tasksDataExists && cumulativeChartDataExists"
                                    class="my-4"></v-divider>
                                <div v-show="cumulativeChartDataExists">
                                    <MyProgressPageMultiLineChart :chart-data="cumulativeChartData" :enabledType="false"
                                        :chart-options="chartOptions" :chart-title="cumulativeChartTitle" />
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                </v-expansion-panels>
                <MENDFooter />
            </v-row>
        </v-container>
    </v-app>

</template>

<script>
import MENDFooter from '../MENDFooter.vue';
import axios from 'axios';
import NavBar from '../NavBar.vue';
import ProgressChartDropdown from './ProgressChartDropdown.vue';
import 'chart.js/auto';
// import { ref } from "vue";


// import PatientAnxietyChart from "@/components/my-progress/MyProgressPageLineChart.vue";
import MyProgressPageLineChart from '@/components/my-progress/MyProgressPageLineChart.vue';
import MyProgressPageMultiLineChart from '@/components/my-progress/MyProgressPageMultiLineChart.vue';
import MyProgressPageTaskBarChart from '@/components/my-progress/MyProgressPageTaskBarChart.vue';
import MyProgressPageBarChart from '@/components/my-progress/MyProgressPageBarChart.vue';

// var anxietyData = ref(null);


// const apiUrl = `/get-by-patient-in-dates/${encryptedPatientId2}/${minDate}/${maxDate}`;

export default {

    name: "MyProgress",
    components: {
        NavBar,
        MENDFooter,
        MyProgressPageLineChart,
        MyProgressPageMultiLineChart,
        MyProgressPageTaskBarChart,
        MyProgressPageBarChart,
        ProgressChartDropdown
        // Bar
    },
    data() {
        return {
            intervalTypes: ["Days", "Weeks", "Years"],
            wellnessTypes: ["Mood", "Anxiety"],
            chartDataChartTypes: ["Line", "Bar"],
            chartDataChartType: "Line",
            progressSummary: {
                patient: "Loading Patient",
                summary: "",
            },
            selectedChartType: "Anxiety",
            intervalType: "Days",
            wellnessType: "Mood",
            optionsDialog: false,
            showMenu: false,
            chartDataExists: false,
            chartData: {
                labels: ['January', 'February', 'March'],
                datasets: [{
                    label: 'Dummy Chart',
                    data: [40, 20, 12]
                }]
            },
            cumulativeChartDataExists: false,
            cumulativeChartData: {
                labels: ['January', 'February', 'March'],
                datasets: [{
                    label: 'Dummy Chart',
                    data: [40, 20, 12]
                }]
            },
            cumulativeChartTitle: "Cumulative Average Wellness Ratings Over Days of App Use",
            tasksDataExists: false,
            tasksData: {
                labels: ['January', 'February', 'March'],
                datasets: [{
                    label: 'Dummy Chart',
                    data: [40, 20, 12]
                }]
            },
            tasksChartTitle: "Tasks Completed Per Day Over Previous Two Weeks",
            chartOptions: {
                responsive: true
            },
            patientId: null,
            isProviderView: null,
            // ✅ Correctly define reactive state inside `data()`
            startDatePicker: false,
            endDatePicker: false,
            datePickerOptions: false,
            // dateRange: [null, null],
            startDate: null,
            endDate: null,
            previousTwoWeeks: {start: null, today: null}
        }
    },
    async mounted() {
        this.isProviderView = (this.$route.query.isProviderView) ? this.$route.query.isProviderView : "false";
        if (this.isProviderView && this.isProviderView === "true") {
            this.patientId = this.$route.query.patientId;
        } else {
            this.patientId = localStorage.getItem("patientId");
        }
        var dateRange = this.getPreviousTwoWeeksFromToday();
        this.previousTwoWeeks.start = dateRange[0];
        this.previousTwoWeeks.today = dateRange[1];
        await this.fetchWellnessStats();
        await this.fetchPatientCompletedTasks();
        await this.fetchPatientTimeMoodAnxietyStats();
        await this.fetchProgressSummary();
    },
    computed: {

        // Adjust location of chart filter buttons based on screen size
        today() {
            return new Date().toISOString().split("T")[0]; // Gets today's date in YYYY-MM-DD format
        },
        justifyProgressChartButtons() {
            let prefix = "d-flex"
            switch (this.$vuetify.display.name) {
                case "md", "lg": return `${prefix} justify-end`;
            }
            return `${prefix} justify-center`;
        },

        // Adjust truth value based on screen size
        screenAtLeastMedium() {
            switch (this.$vuetify.display.name) {
                case "md", "lg": return true;
            }
            return false;
        }
    },
    methods: {
        dummy() {
            console.log("Dummy function");
        },
        getPreviousTwoWeeksFromToday(){
            const today = new Date();
            let startDate = new Date();
            startDate.setDate(today.getDate() - 13);
            var firstLastDates = [startDate, today];
            return firstLastDates;
        },
        setChartDataChartType(value) {
            if (this.chartDataChartType !== value) {
                this.chartDataChartType = value;
            }
        },
        setWellnessType(value) {
            if (this.wellnessType !== value) {
                this.wellnessType = value;
                this.selectedChartType = value; // ✅ Dynamically update `selectedChartType`
                this.fetchWellnessStats
            }
        },
        setIntervalType(value) {
            if (this.intervalType !== value) {
                this.intervalType = value;
            }
        },
        applyDateRange() {
            // ✅ Check if `dateRange` exists and both values are selected
            if (!this.dateRange || this.dateRange.length !== 2 || !this.dateRange[0] || !this.dateRange[1]) {
                console.error("Invalid date range: Please select both start and end dates.");
                return;
            }

            // ✅ Convert dates to YYYY-MM-DD format to avoid `null.getDate()` errors
            this.startDate = new Date(this.dateRange[0]).toISOString().split("T")[0];
            this.endDate = new Date(this.dateRange[1]).toISOString().split("T")[0];

            console.log(`Selected Date Range: ${this.startDate} to ${this.endDate}`);

            // ✅ Fetch new data based on selected date range
            //this.fetchWellnessStats();

            // ✅ Close the date picker dialog
            this.showDatePicker = false;
        },
        async fetchWellnessStats() {
            this.chartDataExists = false;
            try {
                axios.defaults.baseURL = process.env.VUE_APP_API_URL;
                // const minDate = "2025-01-20";
                // const maxDate = "2025-01-28";
                const start = (this.startDate) ? this.startDate.toDateString() : null;
                const end = (this.endDate) ? this.endDate.toDateString() : null;
                let apiUrl = "";
                if (this.wellnessType.toLowerCase() == "anxiety") {
                    apiUrl = `api/patientanxiety/rating-stats/${this.patientId}?period=${this.intervalType}&minDate=${start}&maxDate=${end}`;
                    this.selectedChartType = "Anxiety"

                } else if (this.wellnessType.toLowerCase() == "mood") {
                    apiUrl = `api/patientmood/rating-stats/${this.patientId}?period=${this.intervalType}&minDate=${start}&maxDate=${end}`;
                    this.selectedChartType = "Mood"
                }

                const response = await axios.get(apiUrl, {
                    headers: { Accept: "application/json" }
                });

                // Sort the dates in order from oldest to latest
                const data = response.data.reverse();
                // Extract labels (dates) and values (anxiety levels)
                const dates = data.map(entry => entry.ratingDate); // Avoid duplicate 'labels' declaration
                const wellnessLevels = data.map(entry => entry.wellnessRating);

                // Update chart data
                // this.chartType = "Mood"; // ✅ Store `chartType` separately

                this.chartData = {
                    labels: dates, // Use 'dates' instead of redeclaring 'labels'
                    datasets: [
                        {
                            label: `${this.wellnessType} Levels Over Time`,
                            data: wellnessLevels,
                            borderColor: "blue",
                            backgroundColor: "rgba(0, 0, 255, 0.2)",
                            fill: true,
                            tension: 0.3
                        }
                    ]
                };
                this.chartDataExists = (dates.length > 0) ? true : false;
            } catch (error) {
                console.error("API Error:", error);
                if (error.response) {
                    console.error("Response Status:", error.response.status);
                    console.error("Response Data:", error.response.data);
                }
            }
        },
        async fetchPatientCompletedTasks() {
            this.tasksDataExists = false;
            try {
                axios.defaults.baseURL = process.env.VUE_APP_API_URL;
                var firstLastDates = this.previousTwoWeeks;
                // Get patient completed tasks for previous two weeks
                let url = `api/patientcompletedtask/completion-stats/${this.patientId}
                ?period=days&minDate=${firstLastDates.start.toDateString()}&maxDate=${firstLastDates.today.toDateString()}`;
                const response = await axios.get(url);
                const data = response.data.reverse();

                // Extract labels (dates) and values (anxiety levels)
                const dates = data.map(entry => entry.tasksCompletedDate); // Avoid duplicate 'labels' declaration
                const sumsPerDay = data.map(entry => entry.sumCompleted);

                this.tasksData = {
                    labels: dates, // Use 'dates' instead of redeclaring 'labels'
                    datasets: [
                        {
                            label: `Tasks Completed Per Day`,
                            data: sumsPerDay,
                            borderColor: "blue",
                            backgroundColor: "rgba(0, 0, 255, 0.2)",
                            fill: true,
                            tension: 0.3
                        }
                    ]
                };
                this.tasksDataExists = (dates.length > 0) ? true : false;
            } catch (error) {
                console.log(error);
            }
        },
        async fetchPatientTimeMoodAnxietyStats() {
            this.cumulativeChartDataExists = false;
            try {
                axios.defaults.baseURL = process.env.VUE_APP_API_URL;
                let apiUrl = "";
                apiUrl = `api/patienttimemoodanxiety/${this.patientId}`;


                const response = await axios.get(apiUrl, {
                    headers: { Accept: "application/json" }
                });

                // Sort the dates in order from oldest to latest
                const data = response.data;

                // Extract labels (dates) and values (anxiety levels)
                const days = data.map(entry => `${entry.daysUsed}`); // Avoid duplicate 'labels' declaration
                const cumulativeAvgMoods = data.map(entry => entry.cumulativeAvgMood);
                const cumulativeAvgAnxieties = data.map(entry => entry.cumulativeAvgAnxiety);

                // Update chart data
                // ✅ Store `chartType` separately

                this.cumulativeChartData = {
                    labels: days, // Use 'dates' instead of redeclaring 'labels'
                    datasets: [
                        {
                            label: `Average Mood`,
                            data: cumulativeAvgMoods,
                            borderColor: "blue",
                            backgroundColor: "rgba(0, 0, 255, 0.2)",
                            fill: false,
                            tension: 0.3
                        },
                        {
                            label: `Average Anxiety`,
                            data: cumulativeAvgAnxieties,
                            borderColor: "red",
                            backgroundColor: "rgba(0, 0, 255, 0.2)",
                            fill: false,
                            tension: 0.3
                        }
                    ]
                };
                this.cumulativeChartDataExists = (days.length > 0) ? true : false;
            } catch (error) {
                console.error("API Error:", error);
                if (error.response) {
                    console.error("Response Status:", error.response.status);
                    console.error("Response Data:", error.response.data);
                }
            }
        },
        async fetchProgressSummary() {
            try {
                axios.defaults.baseURL = process.env.VUE_APP_API_URL;
                const isProvider = (this.$route.query.isProviderView) ? this.$route.query.isProviderView : "false";
                const response = await axios.get(`api/patient/my-progress-overview/${this.patientId}?isProvider=${isProvider}&date=${this.previousTwoWeeks.today.toDateString()}`);
                console.log(`This is the progress summary ${response.data}`);
                this.progressSummary = response.data;
            } catch (error) {
                console.log(error);
            }
        }

    },
    watch: {
        intervalType() {
            this.fetchWellnessStats();
        },
        wellnessType() {
            this.fetchWellnessStats();
        },
        chartDataChartType() {
            console.log(`New chart type: ${this.chartDataChartType}`)
        },
        startDate() {
            this.fetchWellnessStats();
        },
        endDate() {
            this.fetchWellnessStats();
        }
    }
}
</script>

<style>
.bg-aqua-teal {
    background-color: #08B6AA;
}

.bg-bright-orange {
    background-color: #ff6d44;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 10px 15px;
  height: 60px;
  border-bottom: 2px solid #293840;
}
</style>